import 'altcha';
import { resetPassword } from './auth-api';
import { API_BASE } from '../network/api';

export function renderResetPassword(root: HTMLElement, token: string, onSuccess: () => void): () => void {
  root.innerHTML = `
    <div class="min-h-screen grid place-items-center px-5 py-10 bg-auth-gradient">
      <form class="w-full max-w-[420px] bg-auth-card border border-border rounded-lg p-8 shadow-lift" id="reset-form" novalidate>
        <h1 class="mb-2 font-heading text-2xl text-gold tracking-wide">Choose a new password</h1>
        <p class="mb-6 text-sm text-text-dim">You'll be redirected to sign in after reset.</p>
        <div id="reset-error" class="mb-3.5 px-3 py-2.5 bg-error/[0.08] border border-error/40 rounded text-error text-[13px]" hidden></div>
        <label class="block mb-3.5">
          <span class="block mb-1.5 text-[13px] text-text-dim">New password (min 8 chars)</span>
          <input type="password" name="newPassword" autocomplete="new-password" minlength="8" required
            class="w-full px-3 py-2.5 bg-surface text-text border border-border rounded outline-none transition-colors duration-[120ms] focus:border-gold focus:shadow-glow" />
        </label>
        <div class="mb-3.5">
          <altcha-widget challenge="${API_BASE}/auth/altcha-challenge" auto="onload" name="altcha"></altcha-widget>
        </div>
        <button type="submit" class="inline-block w-full p-3 bg-gold text-bg font-bold border-0 rounded transition-colors duration-[120ms] hover:bg-gold-bright disabled:bg-border disabled:text-text-dim disabled:cursor-not-allowed" id="reset-btn">Set new password</button>
      </form>
    </div>
  `;

  const form = root.querySelector('#reset-form') as HTMLFormElement;
  const errEl = root.querySelector('#reset-error') as HTMLDivElement;
  const btn = root.querySelector('#reset-btn') as HTMLButtonElement;

  const handler = async (e: Event) => {
    e.preventDefault();
    errEl.hidden = true;
    const fd = new FormData(form);
    const altchaPayload = fd.get('altcha') as string | null;
    if (!altchaPayload) {
      errEl.textContent = 'Please wait for verification to complete.';
      errEl.hidden = false;
      return;
    }
    btn.disabled = true;
    btn.textContent = 'Saving…';
    try {
      await resetPassword(token, String(fd.get('newPassword') ?? ''), altchaPayload);
      onSuccess();
    } catch (err) {
      errEl.textContent = (err as Error).message;
      errEl.hidden = false;
      btn.disabled = false;
      btn.textContent = 'Set new password';
    }
  };
  form.addEventListener('submit', handler);
  return () => form.removeEventListener('submit', handler);
}
